module.exports = __webpack_public_path__ + "static/media/variance.fd95e7dc.svg";